<app-header label="Exceptions" sub_label="View Exceptions"></app-header>

<div class="flex h-[calc(100vh-56px)] overflow-hidden bg-gray-50">

    <!-- LEFT: Image Viewer -->
    <div class="flex-1 relative flex flex-col bg-white m-4 rounded-2xl shadow-sm overflow-hidden">

        <!-- Zoom / Rotate Controls -->
        <div class="absolute left-4 top-4 z-10 flex flex-col gap-2">
            <button (click)="zoom_in()" class="w-9 h-9 bg-white rounded-full shadow flex items-center justify-center hover:bg-gray-100 transition-colors border border-gray-200">
                <i class="bx bx-zoom-in text-lg text-gray-600"></i>
            </button>
            <button (click)="zoom_out()" class="w-9 h-9 bg-white rounded-full shadow flex items-center justify-center hover:bg-gray-100 transition-colors border border-gray-200">
                <i class="bx bx-zoom-out text-lg text-gray-600"></i>
            </button>
            <button (click)="reset_zoom()" class="w-9 h-9 bg-white rounded-full shadow flex items-center justify-center hover:bg-gray-100 transition-colors border border-gray-200">
                <i class="bx bx-reset text-lg text-gray-600"></i>
            </button>
        </div>

        <!-- Image Display -->
        <div class="pdf-content-container flex-1 relative w-full overflow-auto flex justify-center items-start flex-col bg-gray-100">
            @if (current_image) {
            <div class="paper-wrapper relative mx-auto w-[480px] flex flex-col h-full overflow-auto no-scrollbar items-center" [style.zoom]="zoom_level">
                <div class="relative w-full">
                    <img [src]="current_image" alt="Answer Script" [style.maxHeight.px]="image_max_height" class="w-full object-contain rounded-lg bg-gray-200 select-none" />
                    <div *ngIf="current_image_blur_percent > 0" class="absolute top-0 left-0 w-full backdrop-blur-[50px] pointer-events-none" [style.height.%]="current_image_blur_percent"></div>
                </div>
            </div>
            } @else {
            <div class="flex flex-col items-center gap-3 text-gray-400">
                <i class="bx bx-image text-5xl"></i>
                <span class="text-sm">No images available</span>
            </div>
            }
        </div>

        <!-- Image Navigation -->
        @if (script_images.length > 1) {
        <div class="flex items-center justify-center gap-4 py-3 bg-white border-t border-gray-100">
            <button (click)="prev_image()" [disabled]="current_image_index === 0" class="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center disabled:opacity-40 hover:bg-gray-50 transition-colors">
                <i class="bx bx-chevron-left"></i>
            </button>
            <span class="text-sm text-gray-500">{{ current_image_index + 1 }} / {{ script_images.length }}</span>
            <button (click)="next_image()" [disabled]="current_image_index === script_images.length - 1" class="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center disabled:opacity-40 hover:bg-gray-50 transition-colors">
                <i class="bx bx-chevron-right"></i>
            </button>
        </div>
        }
    </div>

    <!-- RIGHT: Details Panel -->
    <div class="w-[340px] flex flex-col bg-white rounded-2xl shadow-sm m-4 overflow-hidden">

        <!-- Scrollable content -->
        <div class="flex-1 overflow-y-auto flex flex-col gap-4 p-4">

            <!-- Evaluator Info Card -->
            <div class="bg-gray-100 rounded-2xl p-5 flex flex-col gap-3">
                <!-- Name & Role -->
                <div class="flex items-center gap-4">
                    <i class="bx bx-user text-[#3F41D1] flex-shrink-0" style="font-size:28px"></i>
                    <div class="flex flex-col gap-0.5">
                        <p class="font-medium text-gray-900 text-base leading-tight">{{ evaluator_name }}</p>
                        <p class="text-sm text-gray-400">{{ evaluator_role }}</p>
                    </div>
                </div>
                <!-- Contact -->
                <div class="flex items-center gap-4">
                    <i class="bx bx-phone text-[#3F41D1] flex-shrink-0" style="font-size:28px"></i>
                    <div class="flex flex-col gap-0.5">
                        <p class="font-medium text-gray-900 text-base leading-tight">{{ evaluator_contact ? '+91 ' + evaluator_contact : '-' }}</p>
                        <p class="text-sm text-gray-400">{{ evaluator_email }}</p>
                    </div>
                </div>
            </div>

            <!-- Exception Details Card -->
            <div class="bg-gray-100 rounded-2xl p-4 flex flex-col gap-3">
                <div>
                    <p class="text-xs font-medium text-gray-400 mb-1">Exception</p>
                    <p class="text-sm font-medium text-gray-800">{{ exception_types }}</p>
                </div>
                <div>
                    <p class="text-xs font-medium text-gray-400 mb-1">Description</p>
                    <p class="text-sm font-medium text-gray-700 leading-relaxed">{{ description || 'N/A' }}</p>
                </div>
            </div>

            <div class="h-px bg-gray-200"></div>
            <!-- Action Form (admin only) -->
            @if (is_admin) {
            <div class="flex flex-col gap-4">

                <!-- Action Dropdown -->
                <div [class.action-reply]="selected_action === 'reply'" [class.action-reject]="selected_action === 'reject'" [class.action-resolved]="selected_action === 'mark_as_resolved'">
                    <app-select-input label="Action" placeholder="Select Action" class="w-full" [options]="action_options" [(ngModel)]="selected_action" (valueChange)="on_action_change()">
                    </app-select-input>
                </div>

                <!-- Reply: Comment only -->
                @if (selected_action === 'reply') {
                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">Comment <span class="text-red-500">*</span></label>
                    <div class="relative">
                        <textarea [(ngModel)]="comment" rows="8" maxlength="200" placeholder="Start Typing...." class="w-full border border-gray-200 rounded-xl px-3 py-2 pb-6 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30 focus:border-[#3F41D1] transition-all">
                        </textarea>
                        <span class="absolute bottom-2 right-3 text-xs text-gray-400 pointer-events-none">{{ comment.length }}/200</span>
                    </div>
                </div>
                }

                <!-- Assign: Role + User + optional Comment -->
                @if (selected_action === 'assign') {
                <app-select-input label="Role" placeholder="Select Role" class="w-full" [options]="role_options" [(ngModel)]="assigned_role_id" (valueChange)="on_role_change()">
                </app-select-input>
                <div class="relative">
                    <i *ngIf="!assigned_user_id" class="bx bx-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xl z-10 pointer-events-none"></i>
                    <app-select-input label="Assign User" placeholder="Select User" class="w-full assign-user-select" [options]="user_options" [(ngModel)]="assigned_user_id">
                    </app-select-input>
                </div>
                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">Comment</label>
                    <div class="relative">
                        <textarea [(ngModel)]="comment" rows="8" maxlength="200" placeholder="Start Typing...." class="w-full border border-gray-200 rounded-xl px-3 py-2 pb-6 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30 focus:border-[#3F41D1] transition-all">
                        </textarea>
                        <span class="absolute bottom-2 right-3 text-xs text-gray-400 pointer-events-none">{{ comment.length }}/200</span>
                    </div>
                </div>
                }

                <!-- Reject: Comment only -->
                @if (selected_action === 'reject') {
                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">Comment</label>
                    <div class="relative">
                        <textarea [(ngModel)]="comment" rows="8" maxlength="200" placeholder="Start Typing...." class="w-full border border-gray-200 rounded-xl px-3 py-2 pb-6 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30 focus:border-[#3F41D1] transition-all">
                        </textarea>
                        <span class="absolute bottom-2 right-3 text-xs text-gray-400 pointer-events-none">{{ comment.length }}/200</span>
                    </div>
                </div>
                }

            </div>
            } <!-- end is_admin -->

            <!-- Evaluator / Assigned User Reply Form -->
            @if (evaluator_can_reply) {
            <div class="flex flex-col gap-4">
                <p class="text-sm font-semibold text-gray-700">Reply to Admin</p>

                @if (exception?.comment) {
                <div class="bg-gray-50 rounded-xl p-3">
                    <p class="text-xs text-gray-400 mb-1">Admin's Comment</p>
                    <p class="text-sm text-gray-700 leading-relaxed">{{ exception?.comment }}</p>
                </div>
                }

                <div>
                    <label class="block text-xs font-medium text-gray-600 mb-1">Your Reply <span class="text-red-500">*</span></label>
                    <div class="relative">
                        <textarea [(ngModel)]="evaluator_reply_comment" rows="8" maxlength="200" placeholder="Start Typing...." class="w-full border border-gray-200 rounded-xl px-3 py-2 pb-6 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-[#3F41D1]/30 focus:border-[#3F41D1] transition-all">
                        </textarea>
                        <span class="absolute bottom-2 right-3 text-xs text-gray-400 pointer-events-none">{{ evaluator_reply_comment.length }}/200</span>
                    </div>
                </div>
            </div>
            } <!-- end evaluator_can_reply -->

        </div> <!-- end scrollable content -->

        <!-- Submit / Send Reply pinned at bottom -->
        @if (is_admin && selected_action) {
        <div class="p-4 border-t border-gray-100">
            <button (click)="submit()" [disabled]="is_submitting" class="w-full py-3 bg-[#3F41D1] text-white rounded-full font-semibold text-sm hover:bg-[#3234b0] transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
                {{ is_submitting ? 'Submitting...' : 'Submit' }}
            </button>
        </div>
        }
        @if (evaluator_can_reply) {
        <div class="p-4 border-t border-gray-100">
            <button (click)="submit_evaluator_reply()" [disabled]="is_submitting" class="w-full py-3 bg-[#3F41D1] text-white rounded-full font-semibold text-sm hover:bg-[#3234b0] transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
                {{ is_submitting ? 'Sending...' : 'Send Reply' }}
            </button>
        </div>
        }
    </div>
</div>

<!-- Mark as Resolved Confirmation Popup -->
<div *ngIf="show_resolve_modal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
    <div class="bg-white rounded-2xl flex flex-col gap-6 px-8 py-6 w-full max-w-[492px]" style="box-shadow: 0 2px 6px 2px rgba(0,0,0,0.15), 0 1px 2px 0 rgba(0,0,0,0.30)">
        <div class="flex flex-col gap-2">
            <p class="text-xl font-medium text-gray-900 leading-snug">Do you want to mark this issue as resolved?</p>
            <p class="text-sm text-gray-500">The action cannot be undone</p>
        </div>
        <div class="flex items-center gap-4">
            <button (click)="show_resolve_modal = false" class="flex-1 h-11 rounded-full border border-gray-300 bg-white text-gray-700 font-medium text-sm hover:bg-gray-50 transition-colors">
                No
            </button>
            <button (click)="confirm_resolve()" class="flex-1 h-11 rounded-full bg-[#3F41D1] text-white font-medium text-sm hover:bg-indigo-700 transition-colors">
                Yes, Mark As Resolved
            </button>
        </div>
    </div>
</div>